<template>
    <div class='button_wrap'>
        <div class='one_wrap flex-between'>
            <div>
                <i class='iconfont icon-maisiduowei'></i>
            </div>
            <div class='middle'>
                <div class='mid_content flex-start-between'>
                    <div class='content_one'>
                        <div class='content_title'>麦思多维</div>
                        <div class='toButton'><a href='https://www.maxsdsp.com/#/' target='_blank'>公司官网</a></div>
                        <div class='toButton'><a href='https://www.maxsdsp.com/#/product_description' target='_blank'>产品服务</a>
                        </div>
                        <div><a href='https://www.maxsdsp.com/#/contactUs' target='_blank'>联系我们</a></div>
                    </div>
                    <div class="content_two">
                        <div class="content_title">资源平台</div>
                        <div><a href='https://ds.mssdk.vip/home/homeIndex' target='_blank'>数据科学实验系统</a></div>
                        <div><a href="https://ai.mssdk.vip/#/login" target="_blank">人工智能实训系统</a> </div>
                        <div><a href="https://cqipc.mssdk.vip/#/login" target="_blank">MS 数据科学社区</a> </div>

                    </div>
                    <div class='content_three'>
                        <div class='content_title'>专题链接</div>
                        <div><a href='https://vlab.uestc.edu.cn/finance/#/login' target='_blank'>期货、期权交易实验</a>
                        </div>
                        <div><a href='http://116.63.168.62/cdClient/#/login' target='_blank'>跨国投资汇率风险管理</a>
                        </div>
                        <div><a href='https://stock.mssdk.vip/' target='_blank'>证券投资实验</a></div>
                    </div>
                </div>
            </div>
            <div class="QRcode_wrap">
                <div class="flex-between QRcode_img">
                    <div class="img_wrap">
                        <img src="../../assets/img/QRcodeTwo.png" alt="扫描进行关注">
                        <div class="QRcode_name">麦思多维研究院</div>
                    </div>
                    <div class='img_wrap'>
                        <img src='../../assets/img/QRcode.png' alt=''>
                        <div class='QRcode_name'>麦思多维科技</div>
                    </div>
                </div>

            </div>
        </div>
        <div class='copyright'>Copyright c 2016-2022 The Project by MaxSwell.All Rights Reserved</div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    created() {
    },
    methods: {}
};
</script>

<style lang="scss" scoped>

.content_three{
    // margin-top: 20px;
    margin-left: 40px;
}
.content_two{
    margin-left: 50px;
    div{
        position: relative;
        left: 1.5vw;
    }
}
a{
    color: #333;
    font-weight: bold;
    font-family: '微软雅黑';
}
.toButton:hover{
    opacity: 0.8;
    cursor: pointer;
}
a:hover{
    opacity: 0.8;
}
.one_wrap{
    // height: 200px;
    .icon-maisiduowei{
        font-size: 60px;
    }
    .QRcode_wrap{
        width: 18%;
        padding-top: 30px;
        .QRcode_img{
            width: 100%;
            text-align: center;

            .img_wrap{
                text-align: center;
                img{
                    width:100px
                }
                .QRcode_name{
                    width: 100%;
                    font-size: 16px;
                    margin-top: 10px;
                    text-align: center;
                }
            }

        }
    }
    .middle{
        width: 50%;
        letter-spacing: 1px;
        .content_title{
            font-weight: 600;
            // width: 87%;
            letter-spacing: 2px;
            font-size: 20px;
            margin-bottom: 15px;
            line-height: 1;
        }
        .mid_content{
            line-height: 2;
        }
    }

}
.button_wrap{
    width: 100%;
    box-sizing: border-box;
    padding: 60px 200px 30px 200px;
    color: #333;
    background: white;
    .QRcode_title{
        font-size: 25px;
        font-weight: 600;
        margin-bottom: 15px;
        line-height: 2;
    }

}
.copyright{
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.icon-maisiduowei{
    color: #00519D;
    font-size: 60px;
}
</style>
